/* eslint-disable consistent-return */
/* eslint-disable object-shorthand */
import { enqueueSnackbar } from "notistack";
import localStorageAvailable from "../../utils/localStorageAvailable";
import axios from "../../utils/axios";


const createInvoice = async (user, data, logout, url, method) => {
    const storageAvailable = localStorageAvailable();

    const accessToken = storageAvailable
        ? localStorage.getItem("accessToken")
        : "";
    const config = {
        method,
        maxBodyLength: Infinity,
        url,
        headers: {
            authorization: `Bearer ${accessToken}`,
            user,
        },
        data: data,
    };
    try {
        const response = await axios.request(config);
        return response;
    } catch (error) {
        console.log(error);
        
        if (error?.data === "Verification timeout") {
            return;
        }
        if (error?.status === 401) {
            enqueueSnackbar("Un Authorized Request", {
                variant: "error",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            });
            logout();
        }
        enqueueSnackbar(error?.data?.message || error?.data || error.message, {
            variant: "error",
            anchorOrigin: {
                vertical: "top",
                horizontal: "right",
            },
        });
    }
};

export default createInvoice;
